// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/padlock.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
.ChartType_calendar-style__tgUwq {
  height: 30rem;
}

.ChartType_title__a4Ppl {
  margin-bottom: 0.5rem;
  color: white;
  margin: 0.25rem;
}

.ChartType_warning__Z1P32 {
  font-size: 0.8rem;
  color: black;
  text-align: center;
  display: flex;
  align-items: center;
  padding: 44% 13% 1% 13%;
  height: 100%;
}

.ChartType_column-holder__PUnqz {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.ChartType_column__E9clE {
  display: flex;
  flex-direction: column;
  margin: 0.3rem;
  width: 50%;
  position: relative;
}

.ChartType_disabled-column__q8Pcr {
  opacity: 0.5;
  pointer-events: none;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.ChartType_test__K1BID {
  background-color: rgba(0, 170, 0, 0.6666666667);
  width: 100%;
  height: 100%;
}

.ChartType_padlock__j\\+Pk6 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: auto 100%;
  height: 7.2rem;
  width: 7.2rem;
}

.ChartType_padlock-wrapper__gvAPE {
  position: absolute;
  padding-top: 2.4rem;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.ChartType_row__EXVi- {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.25rem;
}

.ChartType_type-select__DUWzD {
  padding: 0.375rem 0.75rem;
  font-weight: 400;
  color: #495057;
  width: 100%;
  background-color: white;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.ChartType_type-select__DUWzD:disabled {
  color: #a0a0a0;
}

.ChartType_descriptor__lBGNS {
  margin-left: 0.3rem;
  width: 5rem;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/components/ChartTypePicker/ChartType.module.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;ACvBA;EACE,aAAA;AAeF;;AAXA;EACE,qBAAA;EACA,YAAA;EACA,eAAA;AAcF;;AAXA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAcF;;AAVA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAaF;;AAVA;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;AAaJ;;AAVA;EACE,YAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAaF;;AAVA;EACE,+CAAA;EACA,WAAA;EACA,YAAA;AAaF;;AAVA;EACE,mDAAA;EACA,2BAAA;EACA,4BAAA;EACA,0BAAA;EACA,cAAA;EACA,aAAA;AAaF;;AAVA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAaF;;AAVA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAaF;;AAVA;EACE,yBAAA;EAEA,gBAAA;EACA,cAAA;EACA,WAAA;EAEA,uBAAA;EACA,yBAAA;EACA,sBAAA;AAWF;;AARA;EACE,cDvES;ACkFX;;AARA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;AAWF","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n.calendar-style {\n  height: 30rem;\n}\n\n.title {\n  margin-bottom: 0.5rem;\n  color: white;\n  margin: 0.25rem;\n}\n\n.warning {\n  font-size: 0.8rem;\n  color: black;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  padding: 44% 13% 1% 13%;\n  height: 100%;\n}\n\n.column-holder {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  margin: 0.3rem;\n  width: 50%;\n  position: relative;\n}\n\n.disabled-column {\n  opacity: 0.5;\n  pointer-events: none;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.test {\n  background-color: rgba(0, 170, 0, 0.6666666667);\n  width: 100%;\n  height: 100%;\n}\n\n.padlock {\n  background: url(\"../../images/padlock.svg\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: auto 100%;\n  height: 7.2rem;\n  width: 7.2rem;\n}\n\n.padlock-wrapper {\n  position: absolute;\n  padding-top: 2.4rem;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0.25rem;\n}\n\n.type-select {\n  padding: 0.375rem 0.75rem;\n  font-weight: 400;\n  color: #495057;\n  width: 100%;\n  background-color: white;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n.type-select:disabled {\n  color: #a0a0a0;\n}\n\n.descriptor {\n  margin-left: 0.3rem;\n  width: 5rem;\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendar-style": `ChartType_calendar-style__tgUwq`,
	"title": `ChartType_title__a4Ppl`,
	"warning": `ChartType_warning__Z1P32`,
	"column-holder": `ChartType_column-holder__PUnqz`,
	"column": `ChartType_column__E9clE`,
	"disabled-column": `ChartType_disabled-column__q8Pcr`,
	"test": `ChartType_test__K1BID`,
	"padlock": `ChartType_padlock__j+Pk6`,
	"padlock-wrapper": `ChartType_padlock-wrapper__gvAPE`,
	"row": `ChartType_row__EXVi-`,
	"type-select": `ChartType_type-select__DUWzD`,
	"descriptor": `ChartType_descriptor__lBGNS`
};
export default ___CSS_LOADER_EXPORT___;
